export const getStoredToken = () => {
  const saved = localStorage.getItem("authToken");
  if (!saved) return null;

  const parsed = JSON.parse(saved);

  // Token expired → remove everything
  if (Date.now() > parsed.expiresAt) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userid");
    localStorage.removeItem("useremail");
    return null;
  }

  return parsed.token; // return only token
};
